import { PushNotificationService } from './services/common/services-push-notifications';
import { PermissionChange, DeregisterDevice, RegisterDevice } from './models/notifications.model';
import { Component } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';
import { SwUpdate } from '@angular/service-worker';
import { NotificationService } from './services/common/services-notifications';
import { AuthService } from './services/common/services-auth';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CrumbsService } from './services/common/services-crumbs';
import { AuthState } from './state/auth.state';
import { Select, Actions, Store } from '@ngxs/store';
import { Logout } from './models/auth.model';
import LogRocket from 'logrocket';
import {KeycloakService} from "keycloak-angular";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  dir: Direction = 'ltr';
  opened = false;
  @Select(AuthState.getAuthenticated) authenticated$: Observable<boolean>;
  @Select(AuthState.getUser) user$: Observable<string>;
  public authModel$: any;
  constructor(private updates: SwUpdate, private notificationService: NotificationService,
      private pushNotificationService: PushNotificationService,
      private actions$: Actions, private store: Store,
      public authService: AuthService, private matIconRegistry: MatIconRegistry,
      private domSanitizer: DomSanitizer, private crumbsService: CrumbsService) {
    console.log(`Version: %c${environment.version}`, 'color: #3498db;font-weight:bold;');
    this.initializePushNotifications();

    this.user$.subscribe(u => console.log(`user: ${u}`));
    this.authenticated$.subscribe(async entry => {
      const authState = this.store.selectSnapshot(state => state.auth);
      if (authState.authenticated) {
        this.store.dispatch(new RegisterDevice())
        LogRocket.identify(authState.username, {
          name: authState.username,
          email: authState.username,
        });
      }
    });
    this.matIconRegistry.addSvgIcon(`arrow-expand-left`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/arrow-expand-left.svg`));
    updates.available.subscribe(event => {
      notificationService.snackBar.open(
        'A new version of GapMaps Admin is available. Click to update', 'Reload'
      ).onAction().subscribe(v => {
        updates.activateUpdate().then(_ => document.location.reload());
      });
    });


  }


  async initializePushNotifications() {
    let sw = await navigator.serviceWorker?.getRegistration?.();
    if(!sw) {
      console.log('resorting to event listener')
      sw = await new Promise((resolve, reject) => {
        const controllerChangeListener = (event) => {
          navigator.serviceWorker.removeEventListener('controllerchange', controllerChangeListener)
          resolve(event)
        }
        navigator.serviceWorker.addEventListener('controllerchange', controllerChangeListener)
      });
    }
    if(sw) {
      const permissionState = await navigator.permissions.query({name: 'notifications'});
      const { state } = permissionState;
      await this.store.dispatch(new PermissionChange({state}));
      permissionState.addEventListener('change', ({target: { state }}: any) => this.store.dispatch(new PermissionChange({state})));
    }
  }
  async logout() {
    await this.store.dispatch(new DeregisterDevice()).toPromise();
    this.store.dispatch(new Logout());
  }
}
